
import {appUrl} from '~/assets/helpers';

export default {
  computed: {
    shareOptions() {
      const productUrl = appUrl(this.$route.fullPath);
      return [
        {
          title: 'LinkedIn',
          link: `https://www.linkedin.com/shareArticle?mini=true&url=${productUrl}&title=&summary=&source=`,
          icon: ['fab', 'linkedin-in'],
        },
        {
          title: 'Facebook',
          link: `https://www.facebook.com/sharer.php?u=${productUrl}`,
          icon: ['fab', 'facebook-f'],
        },
        {
          title: 'Klembord',
          text: productUrl,
          icon: ['fas', 'link'],
        },
      ];
    },
  },
  methods: {
    openUrl(option) {
      if (option.link) {
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = option.link;
        a.rel = 'noopener nofollow';
        a.click();
      } else if (option.text) {
        try {
          navigator.clipboard.writeText(option.text);
          this.$toast.success('Link is gekopieerd naar klembord.');
        } catch (e) {
          console.error(e);
          this.$toast.error('Er is iets fout gegaan tijdens het kopiëren van de URL.');
        }
      }
    },
  },
};
